import React from 'react'
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';


const CustomizedTick = ({ x, y, payload }) => {
    return (
        <g transform={`translate(${x},${y})`}>
            <text
                x={0}
                y={0}
                dy={5} // Adjust vertical alignment
                textAnchor="end" // Align the text properly
                transform="rotate(270)" // Rotate the text by 90 degrees
                fill="#616161"
                style={{ fontSize: "14px" }}
            >
                {payload.value}
            </text>
        </g>
    );
};
function DoubleLineChart({ data, keys=[] }) {

    /* This will be enabled to make max value of Y tick dynamic */
    const calculateYRange = (data, keys) => {
        let min = Infinity;
        let max = -Infinity;

        data?.forEach((item) => {
            keys.forEach((key) => {
                if (item[key] !== undefined) {
                    min = Math.min(min, item[key]);
                    max = Math.max(max, item[key]);
                }
            });
        });

        const roundUpToNearest5 = (value) => Math.ceil(value / 5) * 5
        if(max>=5) {
            min = roundUpToNearest5(min - 2)
            max = roundUpToNearest5(max + 2)
        }
        
        return { min, max };
    };
    /* This will be enabled to make max value of Y tick dynamic */
    const yRange = calculateYRange(data, [
        'spendPrctValue',"volumePrctValue"
    ]);

    const generateTicks = (min, max) => {
        const step = max/5;
        let ticks = [];
        if(max>0){
            for (let i = min; i <= max; i += step) {
                if(max>=5) {
                    ticks.push(i);
                } else {
                    ticks.push(i.toFixed(2));
                }
            }
        } else {
            ticks = [1,2,3,4,5];
        }
        
        return ticks;
    };

    /* This will be enabled to make max value of Y tick dynamic */
    // const yTicks = generateTicks(yRange.min, yRange.max, 25);
    // const yTicks = generateTicks(0, 100, 25);
    const yTicks = generateTicks(0, yRange.max);

    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
		return (
			<div style={{ display: 'flex', flexDirection: 'column', background: '#fff', padding: 10 }}>
				<div >{`${payload[0]['payload']['month']}`}</div>
				<div style={{ color: "#33ABDA" }}>{`${keys[0]['name']}`}: {`${payload[0]['payload']['volumePrctValue']}`}</div>
				<div style={{ color: "#B05788" }}>{`${keys[1]['name']}`}: {`${payload[0]['payload']['spendPrctValue']}`}</div>
			</div>
		);
	}

	return null;
    };
    
    return (
        <ResponsiveContainer width="100%" height={400}>
            <LineChart
                width={"100%"}
                height={"100%"}
                data={data}
                margin={{
                    top: 20,
                    right: 10,
                    left: 0,
                    bottom: 30,
                }}
            >
                <CartesianGrid horizontal={true} vertical={true} stroke='#DFDFDF' />
                <XAxis dataKey="month" tickLine={false} tick={<CustomizedTick />} interval={0} />
                <YAxis axisLine={false} tickLine={false} domain={[0, yRange.max]} ticks={yTicks} interval={0} tickFormatter={(value) => `${value}%`}  />
                <Line type="linear" dataKey="spendPrctValue" stroke="#B05788" dot={{ fill: "#B05788", stroke: "#B05788", strokeWidth: 2 }} strokeWidth={3} />
                <Line type="linear" dataKey="volumePrctValue" stroke="#33ABDA" dot={{ fill: "#33ABDA", stroke: "#33ABDA", strokeWidth: 2 }} strokeWidth={3} />
                <Tooltip content={<CustomTooltip />} />
            </LineChart>
        </ResponsiveContainer>
    );
}

export default DoubleLineChart
